export const resolveAssetBase = (apiBase?: string): string => {
  if (!apiBase) return '';
  const trimmedBase = apiBase.replace(/\/+$/, '');
  if (trimmedBase.endsWith('/api')) {
    return trimmedBase.slice(0, -4);
  }
  return trimmedBase;
};

export const resolveLogoUrl = (imagePath?: string | null, apiBase?: string): string => {
  if (!imagePath) return '';
  const trimmedPath = imagePath.trim();
  if (!trimmedPath) return '';
  if (/^https?:\/\//i.test(trimmedPath)) return trimmedPath;
  const assetBase = resolveAssetBase(apiBase);
  const base = assetBase || apiBase || '';
  const normalizedPath = trimmedPath.startsWith('/') ? trimmedPath.slice(1) : trimmedPath;
  if (normalizedPath.startsWith('uploads/')) {
    return `${base}/${normalizedPath}`;
  }
  return `${base}/uploads/logos/${normalizedPath}`;
};
